import { allFolders } from 'owa-locstrings/lib/strings/allfolders.locstring.json';
import {
    allFoldersInArchive,
    allFoldersString,
} from 'owa-locstrings/lib/strings/getSearchScopeDisplayName.locstring.json';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import folderStore, { getEffectiveFolderDisplayName } from 'owa-folders';
import {
    PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID,
    ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID,
} from 'owa-folders-constants';
import type { PrimaryMailboxSearchScope } from 'owa-search-service';
import loc from 'owa-localize';

export default function getSearchScopeDisplayName(
    folderSearchScope: PrimaryMailboxSearchScope,
    isSearchFromFolderScope?: boolean
): string {
    const folderName = folderIdToName(folderSearchScope.folderId);
    if (folderName === PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID && isSearchFromFolderScope) {
        return loc(allFoldersString);
    } else if (folderName === PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID) {
        return loc(allFolders);
    } else if (folderName === ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID) {
        return loc(allFoldersInArchive);
    } else {
        let folder = folderStore.folderTable.get(folderSearchScope.folderId);
        return folder ? getEffectiveFolderDisplayName(folder) : '';
    }
}
